import React, { useState } from "react";

const Modal = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <button style={styles.closeBtn} onClick={onClose}>
                    ✖
                </button>
                {children}
            </div>
        </div>
    );
};
export default Modal;

const styles = {
    container: {
        padding: "20px",
        textAlign: "center",
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
    },
    modal: {
        background: "#fff",
        padding: "20px",
        borderRadius: "8px",
        width: "400px",
        maxWidth: "90%",
        position: "relative",
        boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
    },
    closeBtn: {
        position: "absolute",
        top: "10px",
        right: "10px",
        border: "none",
        background: "transparent",
        fontSize: "18px",
        cursor: "pointer",
    },
    openBtn: {
        padding: "10px 20px",
        fontSize: "16px",
        cursor: "pointer",
        background: "#007bff",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
    },
    form: {
        display: "flex",
        flexDirection: "column",
        gap: "12px",
    },
    input: {
        padding: "8px",
        fontSize: "14px",
        marginTop: "5px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        width: "100%",
    },
    submitBtn: {
        background: "#007bff",
        color: "#fff",
        padding: "10px",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        fontSize: "16px",
    },
};
